export default {"src":"/_next/static/image/public/images/ic_delete.3a41d947839bf18a3dbed97c56abbdaf.svg","height":15,"width":14};